module.exports = __webpack_public_path__ + "img/card_moto.3c10bd9f.svg";